import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/AddAPhoto";
import clsx from "clsx";
import React from "react";
import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";
import { fileUploadActions } from "../actions/fileUploadActions";
import { loadSHOPALBUM } from "../actions/shopLoadAlbum";
import { loadShopData } from "../actions/shopLoadData";
import { IP } from "../config/IP";
import store from "../store/createStore";
import "./ShopManagmentScreen.css";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "space-around",
		overflow: "hidden",
		backgroundColor: theme.palette.background.paper,
	},
	gridList: {
		width: 500,
		height: 450,
	},
	fab: {
		position: "absolute",
		bottom: theme.spacing(2),
		right: theme.spacing(2),
	},
	wrapper: {
		margin: theme.spacing(1),
		position: "relative",
	},
}));

/**
 * The example data is structured as follows:
 *
 * import image from 'path/to/image.jpg';
 * [etc...]
 *
 * const tileData = [
 *   {
 *     img: image,
 *     title: 'Image',
 *     author: 'author',
 *     cols: 2,
 *   },
 *   {
 *     [etc...]
 *   },
 * ];
 */

const AddNewImageForm = (props) => {
	const [success, setSuccess] = React.useState(false);
	const classes = useStyles();
	const state = useSelector((state) => state);
	const buttonClassname = clsx({
		[classes.buttonSuccess]: success,
	});
	const [src, setSrc] = React.useState();
	const [filename, setFilename] = React.useState("");
	const [mimetype, setMimetype] = React.useState("");

	const [image, setImage] = React.useState({ photo: [] });
	const [scrTmp, setScrTmp] = React.useState();
	const [pictures, setPictures] = React.useState([]);
	const setSrcFx = (value) => {
		console.log("setSrcFx=", value);

		setScrTmp(URL.createObjectURL(value));
		setSrc(value);
	};

	const fileChangedHandler = (event) => {
		var fileInput = false;
		if (event.target.files[0]) {
			fileInput = true;
			setFilename(event.target.files[0].name);
			setMimetype(event.target.files[0].mimeType);
		}
		if (fileInput) {
			Resizer.imageFileResizer(
				event.target.files[0], //file
				200, // maxWidth
				200, //maxHeight
				"JPEG", //compressFormat
				100, //quality
				0, //rotation
				(uri) => {
					//responseUriFunc
					console.log("ShopUploadImageResizer=", uri);
					setSrcFx(uri);
					let photo = image.photo;
					//photo.push({ url: uri, name: filename });

					//setImage({ ...image, photo: photo });
				},
				"blob" //outputType
			);
		}
	};
	const handleSaveImage = async (data) => {
		console.log("handleSaveImage data=", data);
		var filedata = data;
		filedata.mimeType = filedata.scr.type;
		console.log("files before HomeEditing Docfiledata=", filedata);
		//console.log("dataURItoBlob=", dataURItoBlob(filedata.scr));
		let file = await new File([filedata.scr], filedata.name, {
			type: filedata.mimeType,
			lastModified: Math.round(new Date().getTime() / 1000),
		});
		console.log("handleSaveImage file=", file);

		let inputs = {
			url: IP.nodeServer + "api/pictures",
			data: [
				{ name: "file", value: file },
				{ name: "office_id", value: state.auth.user.office[0].office_id },

				{
					name: "album",
					value: state.shopAlbum.data.data.album._id,
				},
				{
					name: "id",
					value:
						props.categoryId +
						"#" +
						props.subCategoryId +
						"#" +
						props.productId,
				},
			],
		};
		console.log("ShopUploadImageResizer inputs=", inputs);
		if (state.shopAlbum.data.data.album._id)
			await store.dispatch(fileUploadActions(inputs));
		inputs = {
			url: IP.nodeServer + "api/albums",
			method: "POST",
			data: [
				{
					name: "id",
					value:
						props.categoryId +
						"#" +
						props.subCategoryId +
						"#" +
						props.productId,
				},
				{ name: "description", value: props.title },
				{ name: "name", value: props.name },
			],
		};
		console.log("ShopUploadImageResizer inputs=", inputs);

		await store.dispatch(loadSHOPALBUM(inputs));
		inputs = {
			url: IP.nodeServer + "api/loadShopData",
			method: "POST",
			data: [{ name: "companyId", value: state.auth.user.allCompanies[0]._id }],
		};
		console.log("loadShopData=", inputs);
		if (state.fileupload.isUpLoaded) {
			await store.dispatch(loadShopData(inputs));
		}
	};

	React.useEffect(() => {
		console.log("ShopUploadImageResizer categoryId=", props.categoryId);
		console.log("ShopUploadImageResizer subCategoryId=", props.subCategoryId);
		console.log("ShopUploadImageResizer productId=", props.productId);
		let inputs = {
			url: IP.nodeServer + "api/albums",
			method: "POST",
			data: [
				{
					name: "id",
					value: (
						props.categoryId +
						"#" +
						props.subCategoryId +
						"#" +
						props.productId
					).trim(),
				},
				{ name: "description", value: props.title },
				{ name: "name", value: props.name },
			],
		};
		console.log("ShopUploadImageResizer inputs=", inputs);

		store.dispatch(loadSHOPALBUM(inputs));
	}, []);

	React.useEffect(() => {
		if (state.shopAlbum.saved) {
			setPictures(state.shopAlbum.data.data.pictures);
		}
	}, [state.fileupload.isUpLoaded, state.shopAlbum.saved]);

	console.log("scrTmp=", scrTmp);
	console.log("state.shopAlbum=", state.shopAlbum);
	const images = [
		{
			original: "https://picsum.photos/id/1018/1000/600/",
			thumbnail: "https://picsum.photos/id/1018/250/150/",
		},
		{
			original: "https://picsum.photos/id/1015/1000/600/",
			thumbnail: "https://picsum.photos/id/1015/250/150/",
		},
		{
			original: "https://picsum.photos/id/1019/1000/600/",
			thumbnail: "https://picsum.photos/id/1019/250/150/",
		},
	];

	return (
		<div className={classes.root}>
			{state.shopAlbum.saved ? (
				<>
					<TextField
						autoFocus
						margin="dense"
						id="to"
						label="photo"
						type="file"
						fullWidth
						onChange={fileChangedHandler}
					/>

					<div className="ProductCard">
						<p className="category">Products &#187; </p>
						<p className="name"></p>
						<img src={scrTmp} />
						<p className="saleUnitPrice">
							Selected Image,
							<br /> the specif for this is 200* 200 max
							{src ? (
								<IconButton
									edge="end"
									aria-label="Open"
									onClick={() => {
										handleSaveImage({
											scr: src,
											name: filename,
											mimeType: mimetype,
										});
									}}
								>
									<AddIcon />
								</IconButton>
							) : (
								""
							)}
						</p>
					</div>

					<GridList
						cellHeight={200}
						cellWidth={200}
						className={classes.gridList}
						cols={3}
					>
						{state.shopAlbum.saved
							? pictures.map((tile, index) => {
									console.log(
										"Buffer.from(tile.file.data).toString(base64)",
										tile.file.data
									);

									return (
										<GridListTile key={index} cols={index + 1 || 1}>
											<div className="ProductCard">
												<p className="category">Image &#187; </p>
												<p className="name"></p>
												<img
													src={
														"data:image/png;base64," +
														Buffer.from(tile.file.data).toString("base64")
													}
													width="50"
													height="50"
												></img>

												<p className="saleUnitPrice">{tile.file.name}</p>
											</div>
										</GridListTile>
									);
							  })
							: ""}
					</GridList>
				</>
			) : (
				"Loading Images Info"
			)}
		</div>
	);
};

export default AddNewImageForm;
